import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['subject'];

  static values = {
    triggerText: String,
  }

  connect () {
    this.note = document.querySelector('#subject-note');
    this.toggleHint();
  }

  toggleHint () {
    if (!this.note || !this.subjectTarget) return;

    const triggerValue = this.triggerTextValue?.trim();
    const selectedValue = this.subjectTarget.value?.trim();

    this.note.style.display = selectedValue === triggerValue ? 'block' : 'none';
  }
}
